import CityPageTemplate from "../city-template/CityPageTemplate";
import { saginawConfig } from "./data";

export default function SaginawPage() {
  return <CityPageTemplate config={saginawConfig} />;
}